import { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { usuariosApi, pendientesApi, activarApi } from '../api';

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [pendientes, setPendientes] = useState([]);
  const [cargando, setCargando] = useState(true);

  const cargar = async () => {
    setCargando(true);
    try {
      const [u, p] = await Promise.all([usuariosApi(), pendientesApi()]);
      setUsuarios(u.data);
      setPendientes(p.data);
    } catch(err) { console.error(err); }
    finally { setCargando(false); }
  };

  useEffect(() => { cargar(); }, []);

  const activar = async (id) => {
    try {
      await activarApi(id);
      cargar();
    } catch(err) { alert('Error al activar usuario'); }
  };

  return (
    <Layout titulo="Usuarios">
      <p style={{ fontSize: 20, fontWeight: 600, color: '#fff', marginBottom: '1.25rem' }}>Usuarios</p>

      {pendientes.length > 0 && (
        <div style={{ background: '#141414', border: '1px solid #2a1a00', borderRadius: 12, padding: '1.25rem', marginBottom: '1.5rem' }}>
          <p style={{ fontSize: 14, fontWeight: 600, color: '#fbbf24', marginBottom: 12 }}>Solicitudes pendientes ({pendientes.length})</p>
          {pendientes.map(u => (
            <div key={u.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #1f1f1f' }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500, color: '#fff' }}>{u.nombre} {u.apellido}</div>
                <div style={{ fontSize: 12, color: '#888' }}>{u.email}</div>
              </div>
              <button onClick={() => activar(u.id)} style={{ padding: '6px 16px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                Activar
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {cargando ? (
          <p style={{ padding: '2rem', textAlign: 'center', color: '#555' }}>Cargando...</p>
        ) : (
          <table>
            <thead>
              <tr><th>Nombre</th><th>Usuario</th><th>Email</th><th>Rol</th><th>Estado</th></tr>
            </thead>
            <tbody>
              {usuarios.map(u => (
                <tr key={u.id}>
                  <td style={{ fontWeight: 500 }}>{u.nombre} {u.apellido}</td>
                  <td style={{ color: '#aaa', fontSize: 12 }}>{u.username}</td>
                  <td style={{ color: '#aaa', fontSize: 12 }}>{u.email}</td>
                  <td>
                    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 999, background: u.rol === 'admin' ? '#1a2a3a' : '#1a1a1a', color: u.rol === 'admin' ? '#4a9fd4' : '#aaa' }}>
                      {u.rol}
                    </span>
                  </td>
                  <td>
                    <span style={{ fontSize: 11, color: u.activo ? '#4ade80' : '#f87171' }}>
                      {u.activo ? '● Activo' : '● Inactivo'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </Layout>
  );
}